export default __webpack_public_path__ + "static/media/icon_8_0.4f32a5c2.svg";